<template>
  <div :class="{standardEmbed: true, formGroup: true, isEmbed: item.value}">
    <div v-if="item.value" v-html="item.value" class="embed"></div>
    <textarea name="" class="input" placeholder="iframe code here" rows="4" :value="item.value"></textarea>
    <button type="button" class="btn btnFull" @click="btnEmbed(item, $event)">
      {{item.value ? locale.modify : locale.apply}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'EmbedModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting'
  ],
  methods: {
    btnEmbed (item, e) {
      const value = e.target.previousSibling.value
      if (value === '') {
        alert(this.locale.validate_iframe_empty)
      } else if (!value.startsWith('<iframe') || !value.endsWith('</iframe>')) {
        alert(this.locale.validate_iframe_wrong)
      } else {
        item.value = value
      }
    }
  }
}
</script>
